import React from 'react';
import ReactDOM from 'react-dom/client';
// Importar logger primeiro para silenciar console.logs em produção
import './utils/logger';
// Importar ErrorBoundary cedo para aplicar os patches de DOM
// antes de qualquer outro codigo React ser executado
import './components/ErrorBoundary';
// Inicializar i18n antes de qualquer componente
import {
  LIGHT_I18N_PATHS,
  loadAllTranslations,
  loadAllTranslationsOnFirstInteraction,
} from './i18n';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { registerPwaServiceWorker } from './registerPwaServiceWorker';

registerPwaServiceWorker();

const root = ReactDOM.createRoot(document.getElementById('root'));

// React.StrictMode foi removido para evitar conflitos com scripts externos
// (Meta Pixel, Google Analytics, extensoes de navegador) que podem causar
// erros de "insertBefore" quando o React renderiza componentes duas vezes.
const renderApp = () => root.render(<App />);

// Landings de anúncio pintam só com common/auth; o resto das traduções vem na primeira
// interação (ou ao sair da landing, ver App). As demais rotas esperam o chunk, como antes.
if (LIGHT_I18N_PATHS.includes(window.location.pathname)) {
  renderApp();
  loadAllTranslationsOnFirstInteraction();
} else {
  loadAllTranslations().catch(() => {}).finally(renderApp);
}

function sendWebVitalToDataLayer(metric) {
  if (!metric || typeof window === 'undefined') return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'web_vital',
    web_vital_name: metric.name,
    web_vital_value: Math.round(metric.name === 'CLS' ? metric.value * 1000 : metric.value),
    web_vital_id: metric.id,
    web_vital_route: window.location.pathname,
  });
}

reportWebVitals(sendWebVitalToDataLayer);